import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cfd4f4f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cfd4f4f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd4f4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd4f4f0')) {
      api.createRecord('cfd4f4f0', component.options)
    } else {
      api.reload('cfd4f4f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cfd4f4f0&scoped=true", function () {
      api.rerender('cfd4f4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/renovation-loan/index.vue"
export default component.exports